import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import { CatalogLessonResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
import { ChapterAssetTypename, VideoAssetTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
import { LessonProgressResponseTypename } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService';
import { fullLanguageNameToCode } from 'academy-common-lib/constants/academySupportedLanguages';
export function mapProfessorDescriptions(professor) {
  const descriptions = Object.entries(professor.descriptions).reduce((acc, [langName, value]) => {
    const code = fullLanguageNameToCode(langName);
    if (code && value !== undefined) {
      acc[code] = value;
    }
    return acc;
  }, {});
  return Object.assign({}, professor, {
    descriptions
  });
}
export function chirpLessonToLessonCardModel(lesson) {
  return Object.assign({}, lesson, {
    duration: lesson.duration || 0,
    language: lesson.language.toUpperCase(),
    isDeprecated: !!(lesson.deprecationFinalDate && lesson.deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: false,
    type: 'LESSON',
    __typename: CatalogLessonResponseTypename
  });
}
export function lessonToLessonCardModel({
  lesson,
  progress
}) {
  const language = convertToSupportedLanguage(lesson.language);
  return {
    id: lesson.id,
    internalName: lesson.internalName,
    description: lesson.description,
    name: lesson.name,
    duration: lesson.duration || 0,
    language,
    subCategories: lesson.subCategories,
    hsSoftwareFilters: lesson.hsSoftwareFilters,
    levelFilters: lesson.levelFilters,
    lessonType: lesson.lessonType,
    useCases: lesson.useCases,
    businessObjectives: lesson.businessObjectives,
    visibility: lesson.visibility,
    visibleOnLoggedOutPage: lesson.visibleOnLoggedOutPage,
    featuredHomePage: lesson.featuredHomePage,
    pagePath: lesson.pagePath,
    canonicalUrl: lesson.canonicalUrl,
    previewThumbnailSquareUrl: lesson.previewThumbnailSquareUrl,
    previewThumbnailRectangleUrl: lesson.previewThumbnailRectangleUrl,
    previewThumbnailSquare: lesson.previewThumbnailSquare,
    previewThumbnailRectangle: lesson.previewThumbnailRectangle,
    deprecationWarningDate: lesson.deprecationWarningDate,
    deprecationFinalDate: lesson.deprecationFinalDate,
    deprecationCta: lesson.deprecationCta,
    deprecationMessage: lesson.deprecationMessage,
    isDeprecated: !!(lesson.deprecationFinalDate && lesson.deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: !!(lesson.deprecationWarningDate && lesson.deprecationWarningDate < Date.now()),
    seoBadge: lesson.seoBadge,
    headline: lesson.headline,
    titleTag: lesson.titleTag,
    metaDescription: lesson.metaDescription,
    learnings: lesson.learnings,
    personas: lesson.personas,
    seoRelatedTrackIds: lesson.seoRelatedTrackIds,
    seoRelatedLessonIds: lesson.seoRelatedLessonIds,
    seoRelatedContent: lesson.seoRelatedContent,
    seoProfessorIds: lesson.seoProfessorIds,
    type: 'LESSON',
    __typename: CatalogLessonResponseTypename,
    progress
  };
}
const chirpLessonProgressToCardProgress = (lessonProgress, lesson) => {
  const completedContent = lesson.content.filter(c => {
    var _lessonProgress$conte;
    return ((_lessonProgress$conte = lessonProgress.contentProgress.find(p => p.contentId === c.id)) === null || _lessonProgress$conte === void 0 ? void 0 : _lessonProgress$conte.progressType) === 'COMPLETED';
  });
  const completedDuration = completedContent.reduce((sum, c) => {
    if (c.__typename === VideoAssetTypename && c.duration) {
      return sum + c.duration;
    }
    if (c.__typename === ChapterAssetTypename) {
      return sum + c.readingTimeMinutes * 60;
    }
    return sum;
  }, 0);
  const status = lessonProgress.status === 'NOT_STARTED' ? 'NOT_STARTED' : lessonProgress.status === 'COMPLETED' ? 'COMPLETED' : 'IN_PROGRESS';
  return {
    id: lessonProgress.lessonId,
    context: 'INDIVIDUAL',
    language: undefined,
    updatedAt: lessonProgress.updatedAt || 0,
    type: 'LESSON',
    status,
    hidden: false,
    completedPercentage: lessonProgress.progressLevel || 0,
    remainingDuration: (lesson.duration || 0) - completedDuration,
    __typename: LessonProgressResponseTypename
  };
};
export const maybeLessonCardModelWithProgress = ({
  lesson,
  progress
}) => {
  if (!lesson) {
    return undefined;
  }
  const cardProgress = progress ? chirpLessonProgressToCardProgress(progress, lesson) : undefined;
  return lessonToLessonCardModel({
    lesson,
    progress: cardProgress
  });
};